import { useState, useEffect } from 'react';
import { api } from '../api';
// M-6: opcionális referralId — ha jelen van, a backend visszaadja a `referral` user mezőt
// [F-CANDTRACK] errorStatus: a HTTP státusz strukturáltan (404 → "hirdetés nem található" nézet)
// [CU-869eh36qh] opcionális preview token — inaktív hirdetés előnézete a backend kapun át
export function useJob(slug, referralId, preview) {
    const [job, setJob] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [errorStatus, setErrorStatus] = useState(null);
    useEffect(() => {
        if (!slug) {
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(null);
        setErrorStatus(null);
        api.job(slug, referralId, preview)
            .then(setJob)
            .catch(err => {
            setError(err.message);
            setErrorStatus(typeof err.status === 'number' ? err.status : null);
        })
            .finally(() => setLoading(false));
    }, [slug, referralId, preview]);
    return { job, loading, error, errorStatus };
}
